<template>
  <div class="header">
    <div class="header-notice" :class="{'notice-hide': hideNotice}" v-if="notice.content">
      <div class="layout-content notice-content">
        <span>
          <i class="iconfont noc">&#xe605;</i>
        </span>
        <span>{{notice.content}}</span>
        <a :href="notice.link" target="_blank" @click="noticeClick">
          了解详情
          <i class="iconfont link">&#xe60c;</i>
        </a>
        <i class="iconfont close" @click="closeNotice">&#xe60a;</i>
      </div>
    </div>
    <div class="layout-content header-content">
      <div class="logo header-logo">
        <slot name="logo">
          <router-link to="/">
            <img src="@/image/logo.png" alt="logo" />
          </router-link>
        </slot>
      </div>
      <slot name="nav">
        <div :class="['nav-search-wrap', {'is-overflow': isOverflow}]">
          <transition name="fade-one-level-nav-up" mode="in-out">
            <!-- <div class="nav" v-if="scrollTop < 54"> -->
            <div class="nav">
              <ul>
                <template v-for="(nav) in list">
                  <li :key="nav.id" >
                    <!-- <router-link :to="nav.link" :target="nav.link.indexOf('#')<0?'_blank':'_self'" rel="noopener nofollow" @click="navClick(nav.name)">
                      {{nav.name}}
                    </router-link> -->
                    <a rel="noopener nofollow" @click="navigateTo(nav.link, 64)">
                      {{nav.name}}
                    </a>
                  </li>
                </template>
                <!-- <li v-for="item in ad" class="static" :key="item.alias">
                  <AutoImage :src="item.icon" :scale="50" v-if="item.icon" />
                  <a :href="item.link" target="_blank" @click="navClick(item.name)" rel="noopener nofollow">{{item.name}}</a>
                </li> -->
              </ul>
            </div>
          </transition>
          <!-- 话题导航 -->
          <!-- <transition name="fade-nav-up" mode="out-in">
            <div class="nav two-level-nav" v-if="scrollTop >= 54">
              <ul :style="{opacity: open ? 0 : 1, 'pointer-events': open ? 'none' : ''}">
                <li>
                  <a :class="{selected: id == -1}" href="/">首页</a>
                </li>
                <template v-for="(nav, index) in subNav">
                  <li :key="nav.id" v-if="index < showLength">
                    <a :class="{selected: id == nav.id || id == nav.alias}" :href="nav.type == 1 ? `/topic/${nav.alias || nav.id}` : nav.link" target="_blank" @click="navClick(nav.name)">
                      {{nav.name}}
                    </a>
                  </li>
                </template>
                <li class="more" @click="toggleMoreNav">
                  <span class="dot"></span>
                  <transition name="slide-in">
                    <div class="account-popup-box more-menu" v-if="showMore">
                      <ul>
                        <template v-for="(nav, index) in subNav">
                          <li :key="nav.id" v-if="index >= showLength">
                            <a :class="{selected: id == nav.id}" :href="nav.type == 1 ? `/topic/${nav.alias || nav.id}` : nav.link" target="_blank">
                              {{nav.name}}
                            </a>
                          </li>
                        </template>
                        <li>
                          <a href="/topics"  target="_blank">全部频道</a>
                        </li>
                      </ul>
                    </div>
                  </transition>
                </li>
              </ul>
              <div class="nav-line"></div>
            </div>
          </transition> -->
          <!-- <div :class="['search-container', {'shrinkage': scrollTop >= 54}, {'open': open}]"> -->
          <!-- <div :class="['search-container', {'open': open}]"> -->
            <!-- <div :class="['search-wrap', {focus}]">
              <input 
                type="text" 
                ref="searchInput" 
                placeholder="搜索" 
                class="search-input" 
                v-model="searchKey" 
                @focus="searchFocus"
                @blur="searchBlur" 
                @keyup.enter="search"
              >
              <span class="search iconfont" @click="search">&#xe604;</span>
            </div> -->
          <!-- </div> -->
        </div>
        
      </slot>
      <slot name="login">
        <div class="account">
          <div class="user" @mouseenter="touchMenuStatus = true" @mouseleave="touchMenuStatus = false" v-if="user">
            <Avatar class="avatar" :src="user.avatar" :size="34" />
            <!-- <span class="nickname">{{user.nick}}</span> -->

            <transition name="slide-in">
              <div class="account-popup-box" v-if="touchMenuStatus">
                <ul>
                  <li class="popup-avatar">
                    <div class="avatar-box">
                      <Avatar class="avatar" :src="user.avatar" :size="48" />
                    </div>
                    <h3>{{user.nick}}</h3>
                  </li>
                  <li>
                    <a :href="`/profile/${user.uid}`" target="_blank">我的主页</a>
                  </li>
                  <li>
                    <a href="http://account.geekbang.org/dashboard" target="_blank" rel="noopener nofollow">帐号设置</a>
                  </li>
                  <!-- <li>
                    <span @click="navigation(`/profile/${user.uid}?menu=favorites`)">我的收藏</span>
                  </li> -->
                  <li @click="handleLogout">
                    <span>退出登录</span>
                  </li>
                </ul>
              </div>
            </transition>
          </div>
          <template v-else>
            <span class="route" @click="login">登录</span>
            <span class="line"></span>
            <span class="route" @click="register">注册</span>
          </template>
        </div>
      </slot>
    </div>
  </div>
</template>

<script>
import {mapState, mapActions} from 'vuex'
import utils from '../../../utils/'

import AutoImage from '../../AutoImage'
import Avatar from '../../Avatar'

export default {
  name: 'header-pc',
  components: {
    AutoImage,
    Avatar
  },
  props: {
    id: {
      type: [String, Number],
      default: 0
    },
    list: {
      type: Array,
      default () {
        return []
      }
    },
    subNav: {
      type: Array,
      default () {
        return []
      }
    },
    ad: {
      type: Array,
      default () {
        return []
      }
    },
    notice: {
      type: Object,
      default () {
        return {}
      }
    },
    user: {
      type: [Object, undefined]
    }
  },
  data () {
    return {
      hideNotice: false,
      showMore: false,
      touchMenuStatus: false,
      searchKey: '',
      focus: false,
      open: false,
      scrollTop: 0,
      isOverflow: true
    }
  },
  computed: {
    ...mapState(['loginUser', 'isRobot']),
    /**
     * 计算可显示的导航个数
     */
    showLength () {
      let length = 0

      this.subNav.reduce((max, item) => {
        max -= item.name.replace(/[^\u0000-\u00FF]/g, 'xx').length
        max >= 0 && length++

        length = Math.min(length, 8)

        return max
      }, 50)

      return length
    },
    uid () {
      return this.$route.params.uid
    },
    isSelf () {
      return this.loginUser && this.loginUser.uid + '' === this.uid + ''
    }
  },
  watch: {
    showMore (toggle) {
      toggle && document.addEventListener('click', this.listenerShowMore)
    },
    notice () {
      this.initNoticeStatus()
    },
    scrollTop (top) {
      // 如果话题导航下拉框 打开 时，滚动到头 就关闭
      if (top <= 54) {
        this.showMore = false
        this.isOverflow = true
      } else {
        setTimeout(() => {
          this.isOverflow = false
        }, 400)
      }
    }
  },
  created () {
    this.initNoticeStatus()
  },
  mounted () {
    window.addEventListener('scroll', this.listenerScroll)
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.listenerScroll)
  },
  methods: {
    ...mapActions([
      'logout'
    ]),
    listenerShowMore () {
      this.showMore = false
      document.removeEventListener('click', this.listenerShowMore)
    },
    listenerScroll (event) {
      this.scrollTop = window.scrollY
      this.$refs.searchInput && this.$refs.searchInput.blur()
      this.focus = false
      this.open = false
      this.searchKey = ''
    },
    /**
     * 初始化顶部公告的显示状态
     */
    initNoticeStatus () {
      const storageNotice = utils.storage.get('headerNotice')
      this.hideNotice = this.isRobot || !this.notice.content || storageNotice.close > this.notice.start_time && storageNotice.close < this.notice.end_time || this.$route.meta.hideNotice
      this.$emit('noticeStatus', this.hideNotice)
    },
    /**
     * 关闭公告
     */
    closeNotice () {
      this.hideNotice = true
      utils.storage.set('headerNotice', {
        close: this.notice.time_now
      })
      this.$emit('noticeStatus', this.hideNotice)
    },
    /**
     * 点击公告详情
     */
    noticeClick () {
      window.ga && window.ga('send', 'event', '点击公告详情', 'click')
    },
    /**
     * 开关更多的频道导航
     */
    toggleMoreNav () {
      if (this.showLength >= this.subNav.length) {
        // this.navigation('/topics')
        window.open('/topics')
      } else {
        this.showMore = true
      }
    },
    /**
     * 路由跳转
     */
    navigation (path) {
      this.$router.push(path)
    },
    isOutlink (url) {
      if (!url) return true
      return url.indexOf('http') === 0
    },
    /**
     * 模拟锚点跳转
     *
     * @param  {string}  path   路径
     * @param  {string}  calibration   校准
     */
    navigateTo (path, calibration) {
      if (this.isOutlink(path)) {
        window.location.href = path
      } else if (path.indexOf('#') > -1) {
        this.$router.replace(path, () => {})
        this.$nextTick(() => {
          window.scrollTo(0, document.querySelector(path.slice(1)).offsetTop - calibration)
        })
      } else {
        this.$router.replace(path, () => {})
      }
    },
    /**
     * 点击导航统计ga
     */
    navClick (name) {
      window.ga && window.ga('send', 'event', '导航点击', name)
    },
    /**
     * 跳转到搜索
     */
    search () {
      // 收起状态
      if (this.open) {
        this.doSearch()
      } else {
        if (this.scrollTop >= 54) {
          this.open = true
          this.focus = true
          this.$refs.searchInput.focus()
        } else {
          this.doSearch()
        }
      }
    },
    doSearch () {
      if (this.searchKey) {
        this.focus = false
        utils.search(this.searchKey)
      }
    },
    searchFocus () {
      this.focus = true
    },
    searchBlur () {
      if (this.scrollTop >= 54) {
        setTimeout(() => {
          if (this.open) {
            this.open = false
            this.focus = false
            this.searchKey = ''
          }
        }, 200)
      } else {
        this.focus = false
      }
    },
    /**
     * 跳转到登录
     */
    login () {
      window.ga && window.ga('send', 'event', `「注册/登录」按钮`, `导航`, `pc ${this.$route.name}`)
      utils.login()
    },
    /**
     * 跳转到注册
     */
    register () {
      window.ga && window.ga('send', 'event', `「注册/登录」按钮`, `导航`, `pc ${this.$route.name}`)
      utils.register()
    },
    handleLogout () {
      this.logout()
      if (this.isSelf) {
        window.location.href = '//www.infoq.cn'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../assets/css/common';

.header {
  width: 100%;
  border-bottom: 1px solid $borderGray;
  box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.12);

  &.home {
    border-bottom: none;
    box-shadow: 0 2px 9px 1px rgba(198, 205, 218, 0.25);
  }
}

.header-notice {
  overflow: hidden;
  height: 40px;
  background: $blue;
  @extend %transition;

  &.notice-hide {
    height: 0;
  }
}
.notice-content {
  position: relative;
  height: 40px;
  @extend %center;
  line-height: 20px;
  @include font(12, 400);
  color: #FFF;

  & a {
    margin-left: 15px;
    color: #FFF;
  }

  & .close {
    position: absolute; right: 0;
    @include lineFont(12, 400);
    cursor: pointer;
  }

  & .iconfont {
    @include lineFont(12, 400);

    &.noc {
      position: relative; top: 2px;
      margin-right: 8px;
      @include font(16, 400);
    }
    &.link {}
  }
}

.header-content {
  display: flex;
  height: 64px;
  // height: 48px;
}
.logo {
  margin-left: 7px;
  @extend %center;
  cursor: pointer;
  width: 130px; // height: 17px;

  & img {
    display: block;
    width: 100%;
  }
}

.nav-search-wrap {
  position: relative;
  display: flex;
  align-items: center;
  flex: 1;

  &.is-overflow {
    overflow: hidden;
  }
  // overflow: hidden;
  
  &.gradient-layer:after {
    display: block;
    content: '';
    position: absolute; z-index: 4; left: 0; right: 0; bottom: 0;
    height: 16px;
    background: linear-gradient(to bottom,transparent, #fff 70%);

  }
}

.nav {
  // position: absolute; top: 0; left: 0; right: 174px; bottom: 0;
  position: absolute; top: 0; left: 0; left: 50px; bottom: 0;
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  @extend %transition;

  & > ul {
    display: flex;
    transition: all 0.2s ease-out;
    & > li {
      height: 16px;
      margin: 0 18px;
      @include lineFont(14, 400);
      @extend %animateFontBlack;
      cursor: pointer;

      & a,
      & span {
        @extend %animateFontBlack;
        color: rgba(0,0,0,0.7);
      }

      & .selected {
        position: relative;
        font-weight: 400;
        color: $blue;

        &:after {
          content: ' ';
          display: block;
          position: absolute; left: -7px; bottom: -25px; right: -7px;
          height: 4px;
          background: $blue;
          border-radius: 4px;
        }
      }

      &.more {
        position: relative;
        @extend %center;
        width: 25px;
        text-align: center;

        & em {
          position: absolute; right: -6px; top: 0;
          width: 6px; height: 6px;
          background: $orange;
          border-radius: 6px;
        }

        & .dot,
        & .dot:before,
        & .dot:after {
          width: 3px; height: 3px;
          background: $black;
          border-radius: 3px;
        }

        & .dot {
          display: block;
          position: relative;
        }

        & span:before,
        & span:after {
          position: absolute; top: 0;
          content: ' ';
          display: block;
        }

        & span:before {
          left: -7px;
        }
        & span:after {
          right: -7px;
        }
      }

      &.landing {
        position: relative;

        &:after {
          content: '';
          position: absolute; right: -15px; top: -10px;
          width: 20px; height: 12px;
          background: url('../../../assets/img/landing/nav-gift.png') no-repeat;
          background-size: contain;
          pointer-events: none;
        }
      }

      // &.hot {
      //   position: relative;

      //   &:after {
      //     content: 'HOT';
      //     position: absolute; right: -26px; top: -10px;
      //     @extend %center;
      //     width: 50px; height: 24px;
      //     background: $orange;
      //     border-radius: 24px;
      //     letter-spacing: 2px;
      //     @include lineFont(14, 400);
      //     color: #FFF;
      //     transform: scale(0.5); transform-origin: right top;
      //     pointer-events: none;
      //   }
      // }

      &.static {
        position: relative;

        & img {
          position: absolute; left: 100%; top: -10px;
        }
      }
    }
  } 
}

.two-level-nav {
  right: 60px;
}

// 搜索部分
.search-container {
  position: absolute; z-index: 10; top: 0; right: 0; bottom: 0;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 154px;
  margin-right: 20px;
  transition: all 0.5s ease;
  .search-wrap {
    box-sizing: border-box;
    position: relative;
    @extend %center;
    justify-content: flex-end;
    width: 100%; height: 30px;
    background: #ffffff;
    overflow: hidden;
    will-change: width;
    border: 1px solid $borderGray; border-radius: 15px;

    transition: all 0.3s;

    & .search-input {
      box-sizing: border-box;
      width: 100%;
      padding: 0 30px 0 6px;
      text-indent: 6px;
      border: none;
      font-size: 12px;
    }

    & .search.iconfont {
      position: absolute; z-index: 1; right: 0;
      width: 30px; height: 30px;
      background: #fff;
      text-align: center;
      cursor: pointer;
    }

    &.focus {
      width: 154px;
      border-color: $blue!important;

      & .search {
        color: $blue;
      }
    }
  }

  &.shrinkage {
    width: 30px;

    & .search-wrap {
      border-color: transparent;
    }
  }

  &.open {
    width: 154px;

    & .search-wrap {
      border: 1px solid $borderGray;
    }

    // & .focus {
    //   width: 154px;
    // }
  }
}



// 用户部分
.account {
  position: relative; z-index: 10;
  display: flex;
  align-items: center;
  @include font(14, 400);

  & .search {
    color: rgba(110,118,127,1);
  }

  & .search,
  & .route {
    font-weight: 400;
    cursor: pointer;
  }

  & .line {
    width: 1px; height: 11px;
    margin: 0 10px;
    background: #000;
  }

  
}

.user {
  position: relative;
  display: flex;
  cursor: pointer;

  & .nickname {
    margin: 0 15px 0 10px;
  }
}

.account-popup-box {
  position: absolute; right: -17px; top: 100%; z-index: 1;
  padding-top: 16px;

  & ul {
    position: relative;
    width: 171px;
    padding: 18px 0 0px;
    background: #FFF;
    border: 1px solid $borderGray;
    box-shadow: $shadowGray;
    cursor: default;

    &:before,
    &:after {
      content: ' ';
      display: block;
      position: absolute; right: 20px;
      width: 0; height: 0;
    }

    &:before {
      top: -9px;
      border-bottom: 8px solid $borderGray;
      border-left: 8px solid transparent;
      border-right: 8px solid transparent;
    }

    &:after {
      top: -8px;
      border-bottom: 8px solid #FFF;
      border-left: 8px solid transparent;
      border-right: 8px solid transparent;
    }
  }

  & li {
    // margin-top: 30px;
    // padding: 14px 0;
    text-align: center;
    @include lineFont(14, 400);
    @extend %transition;

    &.popup-avatar {
      position: relative;
      margin-top: 4px;
      padding: 0;

      &:after {
        content: ' ';
        display: block;
        position: absolute; left: 10px; bottom: 0; right: 10px;
        height: 1px;
        background: $borderGray;
      }

      & .avatar-box {
        & img {
          margin: 0 auto;
          border: 4px solid $borderGray;
        }

      }

      & h3 {
        box-sizing: border-box;
        padding: 10px 22px 19px;
        @extend %row;
        @include lineFont(18, 400);
        text-align: center;
      }
    }

    &:not(.popup-avatar):hover {
      background: $lightGray;

      & span,
      & a {
        @extend %animateFontBlack;
        color: $blue;
      }
    }

    & span,
    & a {
      display: block;
      padding: 14px 0;
      @extend %animateFontBlack;
      cursor: pointer;
    }
  }

  &.more-menu {

    & ul {
      padding-top: 24px;
    }

    & li {
      padding: 0;
      line-height: 14px;

      &:last-child {
        position: relative;

        &:before {
          content: ' ';
          display: block;
          position: absolute; left: 10px; top: 0; right: 10px;
          height: 1px;
          background: $borderGray;
        }
      }

      & span,
      & a {
        display: block;
        width: 100%; height: 100%;
      }

      & .selected:after {
        display: none;
      }
    }
  }
}

.slide-in-enter-active,
.slide-in-leave-active {
  transition: all 0.3s ease;
}
.slide-in-enter,
.slide-in-leave-to {
  transform: translateY(-5px);
  opacity: 0;
}

.fade-one-level-nav-up-enter-active,
.fade-one-level-nav-up-leave-active {
  transition: all 0.5s ease;
}

.fade-one-level-nav-up-enter,
.fade-one-level-nav-up-leave-to {
  transform: translateY(-38px);
  opacity: 0;
}

.fade-nav-up-enter-active,
.fade-nav-up-leave-active {
  transition: all 0.5s ease;
}
.fade-nav-up-enter,
.fade-nav-up-leave-to {
  transform: translateY(28px);
  opacity: 0;
}
</style>
